import { render, staticRenderFns } from "./SelectorUI.vue?vue&type=template&id=f83365de&scoped=true&"
import script from "./SelectorUI.vue?vue&type=script&lang=js&"
export * from "./SelectorUI.vue?vue&type=script&lang=js&"
import style0 from "./SelectorUI.vue?vue&type=style&index=0&id=f83365de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83365de",
  null
  
)

export default component.exports